import { BoxConsumableStatus } from "@modules/boxConsumable/entities/boxConsumableType"
import { BoxOfferType } from "@modules/boxOffer/entities/boxOfferTypes"
import { BoxOfferDetailedDtoSchema } from "@modules/boxOffer/gateway/boxOfferDto"
import { CouponDtoSchema } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { PriceObjectDtoSchema } from "@modules/common/priceObject/gateway/priceObjectApiDto"
import { LightPromoCodeDtoSchema } from "@modules/promoCode/gateway/promoCodeDto"
import { z } from "zod"

export const BoxConsumableDetailsDtoSchema = z
  .object({
    id: z.string(),
    type: z.enum(BoxOfferType),
    creationDate: z.iso.datetime(),
    deferredDate: z.string().nullable(),
    endValidity: z.iso.datetime().nullable(),
    status: z.enum(BoxConsumableStatus),
    count: z.number().nullable(),
    referencePrice: PriceObjectDtoSchema.nullable(),
    priceObject: PriceObjectDtoSchema.nullable(),
    usedPromoCode: LightPromoCodeDtoSchema.nullable(),
    coupon: CouponDtoSchema.nullable(),
    offer: BoxOfferDetailedDtoSchema,
  })
  .meta({ id: "BoxConsumableDetailsDtoSchema" })

export type BoxConsumableDetailsDto = z.infer<typeof BoxConsumableDetailsDtoSchema>
